import { useToast } from "@chakra-ui/react";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { AsyncReturnType } from "type-fest";
import { Endpoints, apiService } from "api";

const clearCdlCache = async () => {
  const { data } = await apiService.post<{ removedKeys: number }>(
    Endpoints.Admin.Post.ClearCache
  );

  return data;
};

type UseClearCdlCacheMutationOptions = UseMutationOptions<
  AsyncReturnType<typeof clearCdlCache>,
  unknown,
  void
>;

export const useClearCdlCache = (
  mutationOptions?: UseClearCdlCacheMutationOptions
) => {
  const toast = useToast();

  return useMutation({
    onSuccess: (data) => {
      toast({
        title: `Cache cleared — ${data.removedKeys} ${
          data.removedKeys === 1 ? "key" : "keys"
        } removed`,
        status: "success",
      });
    },
    onError: () => {
      toast({
        title: "Failed to clear cache",
        status: "error",
      });
    },
    ...mutationOptions,
    mutationFn: clearCdlCache,
    mutationKey: ["admin", "clearCdlCache"],
  });
};
